import { ErrorBoundary } from 'react-error-boundary';
import { DefaultErrorBoundaryProps } from './DefaultErrorBoudary.types';
import { ErrorComponent } from '../../ErrorComponent';
import { UpdateErrorBoundary } from './components';

export const DefaultErrorBoundary = ({ children }: DefaultErrorBoundaryProps) => (
  <ErrorBoundary
    fallbackRender={({ error }) => {
      const resolvedError = error instanceof Error ? error : new Error(String(error));

      if (resolvedError.message.includes('Failed to fetch dynamically imported module')) {
        return <UpdateErrorBoundary />;
      }

      return <ErrorComponent error={resolvedError} />;
    }}
  >
    {children}
  </ErrorBoundary>
);
